import { CircleHelp } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";
import { cn } from "@/modern/utils";

interface PromoteStepHelpTriggerProps {
  /** Step name for accessibility, e.g. "Classify" */
  stepLabel: string;
  helpText: string;
  className?: string;
}

export const PromoteStepHelpTrigger = ({ stepLabel, helpText, className }: PromoteStepHelpTriggerProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={cn(
            "inline-flex size-6 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors",
            "hover:bg-muted hover:text-foreground",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
            className,
          )}
          aria-label={`What is ${stepLabel}?`}
        >
          <CircleHelp className="size-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="bottom"
        align="end"
        sideOffset={6}
        className="z-[calc(var(--swivu-bryntum-z-index)+20)] max-w-[240px] text-left border"
      >
        {helpText}
      </TooltipContent>
    </Tooltip>
  );
};
